function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsPass, vsWarning } from '@deephaven/icons';
import { Button, LoadingSpinner } from '@deephaven/components';
import { usePrevious } from '@deephaven/react-hooks';
import IrisGridBottomBar from "./IrisGridBottomBar.js";
import "./PendingDataBottomBar.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HIDE_TIMEOUT = 3000;
var MAX_NUMBER_ROWS_SHOWN = 5;
export function PendingDataBottomBar(_ref) {
  var _ref$isSaving = _ref.isSaving,
    isSaving = _ref$isSaving === void 0 ? false : _ref$isSaving,
    onSave = _ref.onSave,
    onDiscard = _ref.onDiscard,
    discardTooltip = _ref.discardTooltip,
    saveTooltip = _ref.saveTooltip,
    error = _ref.error,
    pendingDataErrors = _ref.pendingDataErrors,
    pendingDataMap = _ref.pendingDataMap,
    onEntering = _ref.onEntering,
    onEntered = _ref.onEntered,
    onExiting = _ref.onExiting,
    _onExited = _ref.onExited;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSuccessShown = _useState2[0],
    setIsSuccessShown = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    wasSuccessShown = _useState4[0],
    setWasSuccessShown = _useState4[1];
  var successTimeout = useRef();
  var prevIsSaving = usePrevious(isSaving);
  var errorMessage = useMemo(() => {
    if (pendingDataErrors.size === 0) {
      return error;
    }
    if (pendingDataErrors.size <= MAX_NUMBER_ROWS_SHOWN) {
      return "Key can't be empty (on pending row".concat(pendingDataErrors.size > 1 ? 's' : '', " ").concat(Array.from(pendingDataErrors.keys()).join(', ').trim(), ")");
    }
    return "Key can't be empty (on ".concat(pendingDataErrors.size, " rows)");
  }, [error, pendingDataErrors]);
  useEffect(function showSuccessMessage() {
    if (prevIsSaving != null && prevIsSaving && !isSaving && errorMessage == null) {
      setIsSuccessShown(true);
      setWasSuccessShown(true);
      successTimeout.current = setTimeout(() => {
        setIsSuccessShown(false);
      }, HIDE_TIMEOUT);
    }
  }, [errorMessage, isSaving, prevIsSaving]);
  useEffect(function hideSuccessMessage() {
    if (successTimeout.current && pendingDataMap.size > 0) {
      // A change just occurred while the success message was still being shown, just hide the success message
      clearTimeout(successTimeout.current);
      setIsSuccessShown(false);
      setWasSuccessShown(false);
    }
  }, [pendingDataMap]);
  useEffect(function cleanupTimeout() {
    return () => successTimeout.current ? clearTimeout(successTimeout.current) : undefined;
  }, []);
  var pendingRowCount = pendingDataMap.size;
  var commitIcon;
  if (isSaving) {
    commitIcon = /*#__PURE__*/_jsx(LoadingSpinner, {
      className: "loading-spinner-vertical-align"
    });
  } else if (wasSuccessShown) {
    commitIcon = vsPass;
  }
  return /*#__PURE__*/_jsxs(IrisGridBottomBar, {
    className: "pending-data-bottom-bar",
    isShown: pendingRowCount > 0 || isSuccessShown || errorMessage != null,
    onEntering: onEntering,
    onEntered: onEntered,
    onExiting: onExiting,
    onExited: () => {
      setWasSuccessShown(false);
      if (_onExited) {
        _onExited();
      }
    },
    children: [errorMessage != null && errorMessage !== '' && /*#__PURE__*/_jsxs("div", {
      className: "error-message",
      children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: vsWarning
      }), /*#__PURE__*/_jsx("span", {
        children: "".concat(errorMessage)
      })]
    }), (errorMessage == null || errorMessage === '') && /*#__PURE__*/_jsx("div", {
      className: "status-message",
      children: pendingRowCount > 0 && /*#__PURE__*/_jsx("span", {
        children: "".concat(pendingRowCount, " row").concat(pendingRowCount > 1 ? 's' : '', " pending")
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "buttons-container",
      children: [!isSaving && !wasSuccessShown && /*#__PURE__*/_jsx(Button, {
        kind: "secondary",
        onClick: onDiscard,
        tooltip: discardTooltip,
        children: "Discard"
      }), /*#__PURE__*/_jsxs(Button, {
        kind: wasSuccessShown ? 'success' : 'primary',
        onClick: onSave,
        icon: commitIcon,
        disabled: isSaving || wasSuccessShown || errorMessage != null,
        tooltip: saveTooltip,
        children: [isSaving && "Committing...", !isSaving && wasSuccessShown && "Success", !isSaving && !wasSuccessShown && "Commit"]
      })]
    })]
  });
}
export default PendingDataBottomBar;
//# sourceMappingURL=PendingDataBottomBar.js.map